<template>
  <div class="teaser-option">
    <v-btn class="remove" @click="decrease"
        :disabled="disabled || selectedTeaser<2" ><v-icon>remove</v-icon></v-btn>
    <div class="value">
      <!-- {{ $t('BetSlip.option.TEASER.' + sport + '.T' + selectedTeaser)}} -->
      <!-- <select v-model="teaserOptions[sport]" class="select" @change="updateSelectedTeaser(sport)"
              :disabled="disabled" >
        <option value="T1">{{ $t('BetSlip.option.TEASER.' + sport + '.T1') }}</option>
        <option value="T2">{{ $t('BetSlip.option.TEASER.' + sport + '.T2') }}</option>
        <option value="T3">{{ $t('BetSlip.option.TEASER.' + sport + '.T3') }}</option>
      </select> -->
      <!--<span>{{ $t('BetSlip.option.TEASER.' + sport +'.' + teaserOptions[sport]) }}</span>-->
      <span >
        <!--<span class="num-value">{{spreads[teaserOptions[index]]}}</span>-->
        <!--<div class="spread-label">{{ $t('BetSlip.tab.TEASER.option.spread') }}</div>-->
        <span class="spread-label" :key="'Tlevel' + '-' + selectedTeaser" >{{ $t('BetSlip.tab.TEASER.option.spread.T' + selectedTeaser) }}
          <!--<span v-if="samesport"><br>{{spreads[teaserOptions[sport]]}}</span>-->
           <span class="spread" v-if="currentSpread"><br>+ {{this.currentSpread}}</span>
           <span class="spread" v-if="!samesport"><br>{{ $t('BetSlip.tab.TEASER.option.spread.mixed') }}</span>
       </span>
      </span>
    </div>
    <v-btn class="add" @click="increase"
      :disabled="disabled || selectedTeaser>2" ><v-icon>add</v-icon></v-btn>
  </div>
</template>

<script>
  import Icon from '@/components/common/Icon'

  export default {
    props: ['index', 'teaserOptions', 'sport', 'spreads', 'disabled', 'currentBetSlipState', 'teaserSelections', 'teasers', 'mixedTeasers', 'teaserSports'],

    data () {
      return {
        currentSpread: ''
      }
    },

    components: {
      Icon
    },

    methods: {
      decrease () {
        if (this.selectedTeaser > 1) {
          this.selectedTeaser--
        }
      },
      increase () {
        if (this.selectedTeaser < 3) {
          this.selectedTeaser++
        }
      },
      updateSelectedTeaser () {
        this.$emit('updateSelectedTeaser', this.sport)
      }
    },

    mounted: function () {
    },

    computed: {
      selectedTeaser: {
        get: function () {
//          console.log('selectedTeaser - get')
          let val = typeof this.teaserOptions !== 'undefined' ? this.teaserOptions[this.index] : ''
//          let val = typeof this.teaserOptions !== 'undefined' ? this.teaserOptions : ''
//          val = val && val.replace(/[^\d.]/g, '')
          val = val && val.split('')
          return val[1] * 1
        },
        set: function (modifiedValue) {
//          console.log('selectedTeaser - set')
//          let newValue = modifiedValue.replace(/[^\d.]/g, '')
          let newValue = 'T' + modifiedValue
          this.$emit('input', {sport: this.sport, index: this.index, t: newValue})
        }
      },
      samesport () {
        var sports = []
        var spreads = []
        var teaserSports = [this.sport]
        if (this.mixedTeasers) {
          teaserSports = this.teaserSports
        }
        for (var sp = 0; sp < teaserSports.length; sp++) {
          let sportId = teaserSports[sp]
          for (var i = 0; i < this.teaserSelections[sportId].length; i++) {
            var selection = this.teaserSelections[sportId][i]
            var sport = selection.idfosport
            var teaserSelection = this.teasers['T' + this.selectedTeaser][selection.idfoselection]
//          console.log('teaserSelection;')
//          console.log(teaserSelection[selection.idfoselection])
            if (teaserSelection && spreads.indexOf(teaserSelection.spread) === -1) {
              spreads.push(teaserSelection.spread)
            }
            if (sports.indexOf(sport) === -1) {
              sports.push(sport)
            }
          }
        }
//        console.log('spreads: ' + spreads)
//        console.log('sports: ' + sports)
        if (spreads.length === 1) {
          this.currentSpread = spreads[0]
        } else {
          this.currentSpread = ''
        }
        return spreads.length <= 1
      }
    },

    watch: {}
  }
</script>

<style lang="stylus" scoped>
  color-border = #CFD6DB

  .TEASER
    .teaser-option-container
      .teaser-option
        .btn
          background: transparent

  .teaser-option
    background: #fff
    border: solid 1px color-border
    border-radius: 3px
    display: flex
    align-items: stretch
    justify-content: center
    height: 42px

    >>> .css
      width: 20px
      height: 20px

    .add,
    .remove,
    .value
      min-width: 42px
      min-height: auto

    .value
      display: flex
      align-items: center
      justify-content: center
      text-align: center
      line-height: 15px
      border-style: solid
      border-width: 0 1px
      border-color: color-border
      min-width: 7rem
      .num-value
        font-weight: bold
        font-size: 14px
        font-size: 1.2em
       .spread-label
         font-size: 10px
         color: #818e95


  .btn
    margin: 1px
    min-width: 30px
    // max-width: 30px
    font-size: 2em
    background: transparent

</style>



// WEBPACK FOOTER //
// src/components/sports/betslip/teaserOption.vue